import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react';
import Div from '../Div';

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      <Link to='https://www.linkedin.com/company/vox-motion' className="cs-center">
        <Icon icon="fa6-brands:linkedin-in" />
      </Link>
      <Link to='https://x.com/VoxMotionCo' className="cs-center">
        <Icon icon="fa6-brands:twitter" />               
      </Link>
      <Link to='https://www.youtube.com/@VoxMotionCo' className="cs-center">
        <Icon icon="fa6-brands:youtube" />              
      </Link>
      
    </Div>
  )
}
